/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import './disco-styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'

// TODO Set the correct article ID here
const ARTICLE_ID = '860734118672'
const isMobile = window.innerWidth < 600

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              «Der Anteil Symptomloser wird stark überschätzt»
              <div className='sub header lead'>
                Wie viele mit dem neuen Coronavirus infizierte Personen
                entwickeln tatsächlich keine Krankheitssymptome? Die Datenlage
                ist widersprüchlich. Epidemiologin Nicola Low hat 200 Studien
                zum Thema analysiert.
              </div>
            </div>
          </h1>
        </div>
      </header>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              <nobr>Marc Brupbacher</nobr>, <nobr>Mathias Lutz</nobr>,{' '}
              <nobr>Patrick Vögeli</nobr>
            </div>
            <div className='ta updated'>Aktualisiert am 8. Mai 2020</div>
          </div>

          <p style={{ marginBottom: '4rem' }}>
            Über den Anteil der asymptomatischen Sars-CoV-2-Infektion besteht
            grosse Uneinigkeit. Die WHO erklärte schon früh: «Der Anteil
            wirklich asymptomatischer Infektionen ist unklar, scheint jedoch
            relativ selten und kein wesentlicher Treiber für die Übertragung zu
            sein.» Diese Aussage wurde durch eine{' '}
            <Link href='https://wwwnc.cdc.gov/eid/article/26/8/20-1274_article'>
              Studie
            </Link>{' '}
            über den gut dokumentierten Covid-19-Ausbruch in einem
            südkoreanischen Callcenter bestätigt, die zeigte, dass nur 1,9% der
            Infizierten während der 14-tägigen Quarantäne keine
            Krankheitszeichen entwickelten. Andere{' '}
            <Link href='https://www.scripps.edu/science-and-medicine/translational-institute/about/news/sarc-cov-2-infection/index.html'>
              Beiträge und Studien
            </Link>{' '}
            kamen hingegen zum Schluss, dass hohe Anteile an infizierten
            Personen keine Symptome entwickeln würden. Eine{' '}
            <Link href='https://linkinghub.elsevier.com/retrieve/pii/S1201971220301399'>
              Analyse
            </Link>{' '}
            bei Japanern, die nach dem Corona-Ausbruch in Wuhan in ihr Land
            zurückgeholt worden waren, ergab einen Anteil von 33 Prozent
            Infizierten, die keine Symptome aufwiesen. Im Zusammenhang mit den
            Ausbrüchen auf den beiden Flugzeugträgern Charles de Gaulle und USS
            Theodore Roosevelt wurden Raten von symptomlosen Infizierten von 63%
            beziehungsweise 50% kommuniziert. Etwa die Hälfte der Menschen, die
            sich angesteckt hatten, würden das gar nicht merken, sagte
            beispielsweise auch Lothar Wieler, Chef des deutschen
            Robert-Koch-Instituts: «Die sehen wir gar nicht.»
          </p>
        </div>
       <div className='ui vertical segment color'>
        <div className='ui text container intro'>
          <p className='introText' style={{textAlign: 'center'}}>Eine Auswahl an Studien zu asymptomatischen Verläufen mit sehr unterschiedlichen Ergebnissen</p>
        </div>
        <div className='ui container'>
          
          <div className='ui two column grid stackable'>
            <div className='column'>
              <div className='wrapper'>
                <div className='titleContainer'>
                  <h3 className='ui infographic header minHeight'>
                    Einwohner der Gemeinde Vo’, Italien
                  </h3>
                </div>

                <div className='contentContainer'>
                  <div className='imageContainer'>
                    <img
                      src={
                        isMobile
                          ? require('../../images/square-vo.svg')
                          : require('../../images/square-vo.svg')
                      }
                      alt=''
                      className='detail'
                    />
                    <p className='graphicIntro'>
                      Nach dem ersten Covid-19-Todesfall in Italien im Februar
                      wurden während der zweiwöchigen Abriegelung der Gemeinde
                      Vo’ an zwei Zeitpunkten 85,9% respektive 71,5% der
                      Bevölkerung getestet.
                    </p>
                  </div>
                </div>
                <div className='relatedLink'>
                  <Link href='https://www.medrxiv.org/content/10.1101/2020.04.17.20053157v1'>
                    Link zur Studie
                  </Link>
                </div>
              </div>
            </div>

            <div className='column'>
              <div className='wrapper'>
                <div className='titleContainer'>
                  <h3 className='ui infographic header'>
                    Passagiere und Besatzung des Kreuzfahrtschiffes Diamond
                    Princess
                  </h3>
                </div>

                <div className='contentContainer'>
                  <div className='imageContainer'>
                    <img
                      src={
                        isMobile
                          ? require('../../images/square-diamond.svg')
                          : require('../../images/square-diamond.svg')
                      }
                      alt=''
                      className='detail'
                    />
                    <p className='graphicIntro'>
                      Am 3. Februar wurde das Kreuzfahrtschiff Diamond Princess
                      in Japan unter Quarantäne gestellt. Am 5. Februar wurden
                      die Passagiere in ihren Kabinen isoliert. Passagiere mit
                      positiven Testergebnissen wurden ausgeschifft und ins
                      Krankenhaus eingeliefert. Die Tests wurden später
                      ausgeweitet, um eine schrittweise Evakuierung der
                      Passagiere zu ermöglichen.
                    </p>
                  </div>
                </div>
                <div className='relatedLink'>
                  <Link href='https://www.eurosurveillance.org/content/10.2807/1560-7917.ES.2020.25.10.2000180'>
                    Link zur Studie
                  </Link>
                </div>
              </div>
            </div>

            <div className='column'>
              <div className='wrapper'>
                <div className='titleContainer'>
                  <h3 className='ui infographic header'>
                    Einwohner der Gemeinde Gangelt, Deutschland
                  </h3>
                </div>

                <div className='contentContainer'>
                  <div className='imageContainer'>
                    <img
                      src={
                        isMobile
                          ? require('../../images/square-gangelt.svg')
                          : require('../../images/square-gangelt.svg')
                      }
                      alt=''
                      className='detail'
                    />
                    <p className='graphicIntro'>
                      In der besonders betroffenen Gemeinde Gangelt in Nordrhein-Westfalen
                      wurden per Stichprobe 919 Menschen aus 405 Haushalten auf
                      eine akute oder überstandene Covid-19-Infektion untersucht
                      - unabhängig davon, ob sie Symptome hatten oder nicht.
                    </p>
                  </div>
                </div>
                <div className='relatedLink'>
                  <Link href='https://www.ukbonn.de/C12582D3002FD21D/vwLookupDownloads/Streeck_et_al_Infection_fatality_rate_of_SARS_CoV_2_infection2.pdf/$FILE/Streeck_et_al_Infection_fatality_rate_of_SARS_CoV_2_infection2.pdf'>
                    Link zur Studie
                  </Link>
                </div>
              </div>
            </div>

            <div className='column'>
              <div className='wrapper'>
                <div className='titleContainer'>
                  <h3 className='ui infographic header'>
                    Angestellte eines Callcenters in Seoul, Südkorea
                  </h3>
                </div>

                <div className='contentContainer'>
                  <div className='imageContainer'>
                    <img
                      src={
                        isMobile
                          ? require('../../images/square-suedkorea.svg')
                          : require('../../images/square-suedkorea.svg')
                      }
                      alt=''
                      className='detail'
                    />
                    <p className='graphicIntro'>
                      Am 9. März wurde ein Bürogebäude nach ersten
                      Infektionsfällen geschlossen und daraufhin Tests an
                      Mitarbeitern und Bewohnern durchgeführt. Bei den positiv
                      auf Sars-CoV-2 getesteten Personen handelte es sich zu 97%
                      um Mitarbeiter eines Callcenters (94 von 97 Infizierten),
                      das sich im 11. Stock des Gebäudes befindet.
                    </p>
                  </div>
                </div>
                <div className='relatedLink'>
                  <Link href='https://wwwnc.cdc.gov/eid/article/26/8/20-1274_article'>
                    Link zur Studie
                  </Link>
                </div>
              </div>
            </div>

            <div className='column'>
              <div className='wrapper'>
                <div className='titleContainer'>
                  <h3 className='ui infographic header'>
                    Japanische Staatsbürger, die aus Wuhan evakuiert wurden
                  </h3>
                  {/* <div>
                      <img
                        src={require('../../images/flagge-island.svg')}
                        className='flag'
                      />
                    </div> */}
                </div>

                <div className='contentContainer'>
                  <div className='imageContainer'>
                    <img
                      src={
                        isMobile
                          ? require('../../images/square-japan.svg')
                          : require('../../images/square-japan.svg')
                      }
                      alt=''
                      className='detail'
                    />
                    <p className='graphicIntro'>
                      Zwischen dem 29. und 31. Januar wurden insgesamt 565
                      japanische Staatsbürger aus der Provinz Wuhan in China mit
                      drei von der Regierung gecharterten Flügen evakuiert. Alle
                      Passagiere wurden bei der Ankunft in Japan auf
                      Krankheitssymptome untersucht und auf Sars-CoV-2 getestet.
                    </p>
                  </div>
                </div>
                <div className='relatedLink'>
                  <Link href='https://www.ijidonline.com/article/S1201-9712(20)30139-9/pdf'>
                    Link zur Studie
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <div className='ui text container' style={{marginTop: '4rem'}}>
          <p>
            Woher kommen diese Unterschiede? Die Gründe liegen in den
            Datenquellen, den Studienanordnungen und der Interpretation der
            Ergebnisse. So wurden in vielen Publikationen Infizierte als
            asymptomatisch deklariert, die eigentlich vorsymptomatisch waren,
            also im späteren Verlauf der Infektion doch noch Symptome
            entwickelten. So war das auch in Zürich nach Ostern, als die
            ärztliche Direktorin der Stadtzürcher Alters- und Pflegezentren,
            Gabriela Bieri-Brüning, sagte, dass in einer Abteilung 40% der
            positiv getesteten Personen symptomfrei blieben (32 von 80). Viele
            Medien titelten auf diese Zahl und schrieben: «Bisher galt die
            Erkenntnis, dass nur junge Infizierte asymptomatische Verläufe
            haben, nicht aber Senioren.» Eine Rückfrage bei Bieri-Brüning nach
            einigen Wochen ergab dann allerdings, dass mindestens die Hälfte der
            32 Personen dann doch noch Symptome entwickelte - womöglich noch
            mehr.
          </p>
          <p>
            So war es auch auf dem Kreuzfahrtschiff Diamond Princess, als zuerst
            berichtet wurde, über 50% seien ohne Symptome; am Schluss waren es
            dann noch{' '}
            <Link href='https://www.eurosurveillance.org/content/10.2807/1560-7917.ES.2020.25.10.2000180'>
              16,1% der Infizierten
            </Link>
            , die angeblich symptomlos blieben.
          </p>
          <p>
            Für Epidemiologin Nicola Low von der Universität Bern, die zu diesem
            Thema für die Covid-19-Task-Force des Bundes einen Übersichtsarbeit
            verfasst hat, kommt das nicht überraschend: «Der Anteil symptomloser
            Infizierter wird stark überschätzt.» Das Team um Low hat bisher über
            200 Studien untersucht zum Thema, und aktualisiert die Analyse
            fortlaufend. «Wir schätzen aufgrund der bis heute berücksichtigten
            Studien , dass 20% bis 30% der Personen, die sich mit Sars-CoV-2
            infizieren, keine Symptome entwickeln», so Low. Dies sei aber
            wirklich ein Maximalwert, die tatsächliche Zahl liege wohl eher noch
            tiefer. «Ich denke, es sind noch weniger. Das Problem ist, dass es
            bisher nur wenige Studien gibt, welche dem Anteil von Symptomlosen
            wirklich seriös auf den Grund gingen. In den meisten Studien waren
            die Personen einfach zum Zeitpunkt des Tests ohne Symptome, später
            wurden sie aber dann doch krank.» Problematisch sei beispielsweise
            jener viel zitierte Beitrag von Michael Day, der im renommierten{' '}
            <Link href='https://www.bmj.com/content/369/bmj.m1375?=&utm_source=adestra&utm_medium=email&utm_campaign=usage&utm_content=daily&utm_term=text'>
              British Medical Journal
            </Link>{' '}
            publiziert wurde und von bis zu 79% asymptomatisch Infizierten in
            China berichtet. Low hat dazu eine{' '}
            <Link href='https://www.bmj.com/content/369/bmj.m1375/rr-5'>
              Antwort
            </Link>{' '}
            publiziert, in welcher sie schreibt: «Die angegebenen Zahlen zeigen
            nicht, dass die grosse Mehrheit der Coronavirus-Infektionen keine
            Symptome hervorruft. Der Beitrag ist ungenau und irreführend. Eine
            asymptomatische Infektion kann nur durch Beobachtung von infizierten
            Personen während der gesamten maximalen Inkubationszeit von 14 Tagen
            festgestellt werden.»
          </p>
          <p>
            Low nimmt an, dass die Gruppe der wirklich Asymptomatischen einen
            kleinen Teil aller mit Sars-Cov-2 infizierten Personen ausmacht.
            «Wir brauchen bessere empirische Belege und eine genauere
            Kommunikation der Ergebnisse, damit die Öffentlichkeit realistisch
            einschätzen kann, bei wie vielen Infizierten die Krankheit
            tatsächlich nicht ausbricht.»
          </p>
          <p>
            Was Low mehr Sorgen bereitet, ist jene Gruppe, welche einige Tage
            vor Ausbruch der Krankheit schon infektiös ist, also bevor sich
            Symptome dann äussern. Welcher Anteil der Infektionen wird von
            diesen Personen verursacht? Eine Studie fand heraus, dass es in
            Singapur 48% und in Tianjin, China, 62% waren. «Modelle berechnen,
            dass 50-60% aller Ansteckungen von asymptomatischen oder
            vorsymptomatischen Personen ausgehen», so Low. «Das ist die Stärke
            des Virus, welches im evolutionären Prozess diese Strategie
            entwickelte, um sich leichter verbreiten zu können.»
          </p>
          <p>
            Daher ist das Social Distancing und ein konsequentes und schnelles
            <Link href='https://interaktiv.tagesanzeiger.ch/2020/so-wirkt-die-coronavirus-contact-tracing-app/'>
              Contact-Tracing
            </Link>{' '}
            wichtig, damit Infektionsketten so schnell wie möglich unterbrochen
            werden könnten. Hier kann die neue App einen wichtigen Beitrag
            leisten, die jetzt aber doch{' '}
            <Link href='https://www.tagesanzeiger.ch/corona-app-muss-zuerst-den-praxistest-bestehen-426359325153'>
              erst im Sommer kommt
            </Link>
            . Wenn nämlich das Umfeld eines Infizierten mit Krankheitssymptomen
            in Quarantäne gesetzt werde, könnten auch die Vorsymptomatischen das
            Virus nicht mehr verbreiten. «In der Schweiz gibt es nur noch
            weniger als 100 neue bestätigte Fälle pro Tag; mit systematischem
            Testen, Kontaktverfolgung, Hygienemassnahmen und Social Distancing
            können wir eine zweite Welle verhindern.»
          </p>
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          [
            'Konzept und Umsetzung',
            'Marc Brupbacher, Mathias Lutz, Patrick Vögeli'
          ]
        ]}
      >
        <div
          className='ui container'
          style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
        >
          <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={[
              '100288781781',
              '147144460867',
              '18727947',
              '172597671179',
              '448154497109',
              '370164650671'
            ]}
          />
        </div>
      </Footer>
    </div>
  )
}
